import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { resolveVectorhubModules } from '../resolvers/moduleResolver.js';
import { useSessionContext } from './SessionContext.js';
const ModulesContext = createContext(null);
export function ModulesProvider({ orgAllowedModules, userModules, children }) {
    const { currentOrgId } = useSessionContext();
    const value = useMemo(() => {
        if (!currentOrgId)
            return { modules: [], instances: [] };
        return resolveVectorhubModules({ orgId: currentOrgId, orgAllowedModules, userModules });
    }, [currentOrgId, orgAllowedModules, userModules]);
    return _jsx(ModulesContext.Provider, { value: value, children: children });
}
export function useModulesContext() {
    const ctx = useContext(ModulesContext);
    if (!ctx) {
        throw new Error('useModules* hooks must be used within a <ModulesProvider>.');
    }
    return ctx;
}
//# sourceMappingURL=ModulesContext.js.map